// src/core/imcmd/ViewUiCommand.ts
/**
 * Команды для работы с view (namespace = "view").
 */
var ViewUiCommand;
(function (ViewUiCommand) {
    /** Закрыть текущее view */
    ViewUiCommand["closeView"] = "closeview";
    /** Перевод обработки команды на сервер */
    ViewUiCommand["ctrl"] = "ctrl";
    /** Полное обновление view (refresh) */
    ViewUiCommand["refresh"] = "refresh";
    /** Полное обновление view (reload) */
    ViewUiCommand["reload"] = "reload";
    /** Копирование из в */
    ViewUiCommand["copy"] = "copy";
    /**
     * Сигнал: нужно отменить выполнение иных действий после обработки командной строки.
     * В частности, используется при обработке кнопок или событий изменения,
     * что бы не отправлять команду или событие об изменении элемента кнопки на сервер
     */
    ViewUiCommand["preventDefault"] = "preventDefault";
    /** Выполнить серверную команду */
    ViewUiCommand["usecmd"] = "usecmd";
    ViewUiCommand["setRequiredValues"] = "setrequiredvalues";
    /** Вызов перезагрузки элемента по ключу */
    ViewUiCommand["reloadItem"] = "reloadItem";
    /** Перезапись html элемента или view */
    ViewUiCommand["reloadResult"] = "reloadResult";
    /** Подтверждение что форма была сохранена в процессе работы серверной команды*/
    ViewUiCommand["saved"] = "saved";
    /** Установить режим формы */
    ViewUiCommand["setFormMode"] = "setFormMode";
    /** Показать справку */
    ViewUiCommand["showHelp"] = "showHelp";
    /** Клик кнопки */
    ViewUiCommand["clickitem"] = "clickitem";
    /** Блокировка выполнения команд (для кнопок) */
    ViewUiCommand["none"] = "none";
})(ViewUiCommand || (ViewUiCommand = {}));

export { ViewUiCommand };
